module.exports = __webpack_public_path__ + "static/img/polidog_flag_right.aec1f5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/polidog_flag_right.png
// module id = 19
// module chunks = 0